
import {Component, Vue} from "vue-property-decorator";
import {PathToProduct, Product} from "@/enum/Product";
import {ProgramPaths} from "@/enum/ProgramPaths";
import {lisansUyariIcerigi} from "@/utils/lisansUyari";
import {URUN_KATALOGU, urunBilgisi} from "@/utils/urunKatalogu";

/**
 * DEV-2113 — bu büroda kapalı bir özelliğin adresine gidilince açılan sayfa.
 *
 * Yeni bir özellik önce seçili bürolara açılır (sunucuda 'ozellik:{anahtar}'). Menü
 * kapalı özelliği hiç göstermez; bu sayfa, adrese doğrudan (yer imi, paylaşılan bağlantı)
 * gidildiğinde çıplak "yetkiniz yok" yerine ne olduğunu söyler. Lisans ya da yetki
 * sorunu değildir; yenileme düğmesi yoktur.
 *
 * Metin, sunucu aynı sebeple 403 verdiğinde açılan uyarıyla aynı kaynaktan gelir.
 */
@Component
export default class OzellikKapaliView extends Vue {
  readonly icerik = lisansUyariIcerigi("feature_disabled", null, null, null);

  /** Kullanıcının girmeye çalıştığı ürün (router query ile taşınır). */
  get gelinenUrun(): Product | null {
    const yol = String(this.$route.query.urun ?? "").replace(/^\//, "");
    if (!yol) return null;
    // @ts-ignore -- PathToProduct string anahtarlı enum
    const urun = PathToProduct[yol];
    return typeof urun === "number" ? urun : null;
  }

  get gelinenUrunAdi(): string | null {
    return urunBilgisi(this.gelinenUrun)?.ad ?? null;
  }

  /** Dönülecek ürün: gelinen ürünün ekranları açıksa o, değilse açık olan ilk ürün; yoksa düğme çizilmez. */
  get donusHedefi(): {ad: string; yol: ProgramPaths; renk: string} | null {
    const acik = URUN_KATALOGU.filter((u) => this.$helper.lisansEkranlariAcikMi(u.urun));
    const hedef = acik.find((u) => u.urun === this.gelinenUrun) ?? acik[0];
    return hedef ? {ad: hedef.ad, yol: hedef.yol, renk: hedef.renk} : null;
  }

  geriDon() {
    if (this.donusHedefi) this.$router.push(this.donusHedefi.yol);
  }
}
